import type { DomainRecord, DomainRecordType } from '@/entities/domain';
import request from '@/shared/api/request';

export const createDomainRecord = (
  domain_name: string,
  record: DomainRecordType,
): Promise<{ record: DomainRecord }> =>
  request({
    url: `/domains/${domain_name}/records/`,
    method: 'POST',
    data: record,
  });
